// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import styled from 'styled-components'
import { UpdatedLabeledInputWrapper } from 'components/Form/updated/UpdatedLabeledInput/styles'

export const UpdatedAutoSuggestWrapper = styled(UpdatedLabeledInputWrapper)`
  > .input {
    border: 0;
    overflow: visible;
    padding: 0;

    > .react-autosuggest__container {
      > .react-autosuggest__input {
        border: 1px solid;
        border-radius: .15em;
        font-size: inherit;
        height: 2em;
        overflow: hidden;
        padding: .25em;
        text-overflow: ellipsis;
        width: 100%;
      }
    }
  }
`
